
import { Options, Vue } from 'vue-class-component';
import RegionEnrollment from "@/components/RegionEnrollment.vue";

@Options({
    components: {
        RegionEnrollment,
    },
})
export default class App extends Vue {
    regionId: number|null = null

    mounted(): void {
        const container = this.$el.parentNode;
        if( typeof container.dataset.regionId === 'undefined' ) {
            return console.error(`RegionEnrollment page component is missing parameter 'data-region-id'`);
        }
        this.regionId = parseInt(container.dataset.regionId);
    }
}
